module.exports = __webpack_public_path__ + "static/media/anthony.c34cb579.png";